class ProductDeliveryCheck extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.controller = new AbortController();
    const form = this.querySelector('form');
    const result = this.querySelector('.product-delivery-check__result');
    if (!form || !result) return;
    const reset = () => result.replaceChildren();
    form.addEventListener('input', reset, { signal: this.controller.signal });
    form.addEventListener('submit', event => {
      event.preventDefault();
      if (!form.reportValidity()) return;
      const zip = form.elements.zip.value.trim();
      if (!/^[0-9]{5}$/.test(zip)) return;
      // Narrower ranges win; conflicting equally specific rules require confirmation.
      const rules = [...this.querySelectorAll('template[data-delivery-rule]')].flatMap(rule => {
        if (!['available', 'unavailable', 'confirm'].includes(rule.dataset.status)) return [];
        const entries = rule.dataset.ranges || rule.dataset.zips || `${rule.dataset.from}-${rule.dataset.to}`;
        const widths = entries.split(/[\s,;]+/).flatMap(entry => {
          const match = entry.match(/^([0-9]{5})(?:-([0-9]{5}))?$/);
          if (!match) return [];
          const from = match[1], to = match[2] || from;
          return from <= zip && zip <= to ? [Number(to) - Number(from)] : [];
        });
        return widths.length ? [{ rule, width: Math.min(...widths) }] : [];
      }).sort((a, b) => a.width - b.width);
      const match = rules[0] && !(rules[1] && rules[0].width === rules[1].width) ? rules[0].rule : null;
      const template = match || this.querySelector('template[data-fallback]');
      result.replaceChildren(...(template ? [template.content.cloneNode(true)] : []));
    }, { signal: this.controller.signal });
  }
  disconnectedCallback() { this.controller?.abort(); }
}
if (!customElements.get('product-delivery-check')) customElements.define('product-delivery-check', ProductDeliveryCheck);
